import { render, staticRenderFns } from "./SuccessReceipt.vue?vue&type=template&id=57ad7af2&scoped=true&"
import script from "./SuccessReceipt.vue?vue&type=script&lang=js&"
export * from "./SuccessReceipt.vue?vue&type=script&lang=js&"
import style0 from "./SuccessReceipt.vue?vue&type=style&index=0&id=57ad7af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad7af2",
  null
  
)

export default component.exports